/**
 * Utility functions for transforming output template formats between display and storage
 */

/**
 * Transform outputTemplate from display format (:variable-name) to storage format ({variable.name})
 * Example: ":metric-heartrate-current" -> "{metric.heartrate.current}"
 */
export const transformOutputForStorage = (text: string): string => {
  return text.replace(/:([a-zA-Z0-9-]+)/g, (match, variableName) => {
    return `{${variableName.replace(/-/g, ".")}}`;
  });
};

/**
 * Transform outputTemplate from storage format ({variable.name}) to display format (:variable-name)
 * Example: "{metric.heartrate.current}" -> ":metric-heartrate-current"
 */
export const transformOutputForDisplay = (text: string): string => {
  return text.replace(/\{([a-zA-Z0-9.]+)}/g, (match, variableName) => {
    return `:${variableName.replace(/\./g, "-")}`;
  });
};

/**
 * Transform mention items by replacing dots with hyphens for display in Beautiful Mentions
 * Example: ["metric.heartrate.current"] -> ["metric-heartrate-current"]
 */
export const transformMentionItemsForDisplay = (
  items: Record<string, string[]>,
): Record<string, string[]> => {
  return Object.entries(items).reduce(
    (acc, [trigger, itemList]) => {
      acc[trigger] = itemList.map((item) => item.replace(/\./g, "-"));
      return acc;
    },
    {} as Record<string, string[]>,
  );
};
